/* eslint-disable */
import { apiWPRequest } from '@/calls/helpers';

const getMultimedia = async (params) => {
  if (params) {
    try {
      const url = `wp-json/wp/v2/multimedia?per_page=${params.limit}&page=${params.page}${params.categoryid ? `&categorie_multimedia=${params.categoryid}` : ''}`;
      const request = await apiWPRequest(url);

      // Check if there is another page before data mapping
      if (request.code === 'rest_post_invalid_page_number') {
        return {
          success: false
        }
      } else {
        const data = request.map((item, index) => {
          return {
            title: item.title.rendered,
            media_video: item.acf.media_video,
            id: item.id,
            slug: item.slug,
            link: item.link,
            bannerID: item.featured_media,
            categoriesID: item.categorie_multimedia,
            data: item,
            categories: null
          };
        });
    
        const catsRequest = await apiWPRequest('wp-json/wp/v2/categorie_multimedia');
        const categories = catsRequest.map((cat, index) => {
          return {
            id: cat.id,
            name: cat.name
          }
        });
    
        for (let i = 0; i < data.length; i++) {
          const multimedia = data[i];
          const req = await getMultimediaImage(multimedia.bannerID);
          const cats = categories.filter(c => multimedia.categoriesID.indexOf(c.id) !== -1);
    
          multimedia.categories = cats;
          multimedia.picture = req.data;
        } 

        return {
          success: true,
          data
        };
      }
    } catch (error) {
      return {
        error: true,
        data: error
      };
    }
  }
};

const getCategories = async () => {
  try {
    const request = await apiWPRequest('wp-json/wp/v2/categorie_multimedia');

    const categories = request.map((cat, index) => {
      return {
        id: cat.id,
        value: cat.id,
        label: cat.name,
      }
    });

    categories.sort((a, b) => {
      if (a.label < b.label) { return -1; }
      if (a.label > b.label) { return 1; }
      return 0;
    });

    return {
      success: true,
      data: categories
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

const getMultimediaImage = async (id) => {
  try {
    const request = await apiWPRequest(`wp-json/wp/v2/media/${id}`);

    return {
      success: true,
      data: {
        src: request.media_details.sizes.medium.source_url,
        src2x: request.media_details.sizes.medium_large.source_url,
        alt: request.alt_text
      }
    };
  } catch (error) {
    return {
      error: true,
      data: null
    }
  }
};


export {
  // eslint-disable-next-line
  getMultimedia,
  getCategories
};
